import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { getCookie } from './cookie-handler';

const cache = {};

export function getEvents() {
    const MOS = parseInt(getCookie('user_mos'), 10) || window.AppConfig.default_mos;
    const FEED_URL = window.AppConfig.event_feed.replace('{mos}', MOS);

    if (FEED_URL in cache) {
        return cache[FEED_URL];
    }

    const config = {
        headers: {},
        credentials: 'include',
    };

    cache[FEED_URL] = fetchPolyfill(FEED_URL, config).then(response => (
        response.json()
    ));

    return cache[FEED_URL];
}

export default {
    getEvents,
};
